import { Pipe, PipeTransform } from '@angular/core';
import { TypeHandicap } from '../../models/typeHandicap';

@Pipe({
	name: 'filterTypeHandicapByName'
})
export class FilterTypeHandicapByNamePipe implements PipeTransform {
	transform(typeHandicap: TypeHandicap[], filter: string): TypeHandicap[] {
		if (
			!typeHandicap ||
			!filter ||
			typeHandicap === null ||
			filter === null ||
			filter === ''
		) {
			return typeHandicap;
		}

		return typeHandicap.filter((typeHandicap: TypeHandicap) => {
			if (typeHandicap.name) {
				// TODO: add lastName too
				return typeHandicap.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
